/* -------------------------------------------------------------------------- */
/*                    Componente SlidingPaneEntityBinnacle                    */
/* -------------------------------------------------------------------------- */
// Este componente permite ver la bitácora de cualquier entidad

import { FormattedMessage, useIntl } from 'react-intl';
import SlidingPane from 'react-sliding-pane';
import { Spinner, Card, Media, CardText, Button, Row, Col, Badge } from 'reactstrap';
import Avatar from '../../../@core/components/avatar';
import moment from 'moment';
import { Send } from 'react-feather';
import TextInput from 'views/formComponents/TextInput';
import { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import useGetBinnacle from '../../screens/Entities/hooks/useGetBinnacle';
import useInsertBinnacleComment from '../../screens/Entities/hooks/useInsertBinnacleComment';
import * as entityTypes from '../../screens/Entities/constants';
import { resolve } from 'path';
import { resolveUnitsIntlLookUp } from 'views/screens/Entities/utils';

interface Props {
  entityName: any;
  entityTypeId: any;
  entityId: any;
  isOpenSlidingPane: any;
  closeSlidingPaneEntityBinnacle: any;
}

const SlidingPaneEntityBinnacle = (props: Props) => {
  const { entityName, entityTypeId, entityId, isOpenSlidingPane, closeSlidingPaneEntityBinnacle } =
    props;
  const { control, handleSubmit, watch, reset } = useForm();
  const intl = useIntl();

  const newComment = watch('comment');
  const [updateBinnacle, setUpdateBinnacle] = useState(true);
  const [executeSave, setExecuteSave] = useState(false);
  const [valuesToSave, setValuesToSave] = useState<any>({});

  const { binnacleList, isFetchingBinnacle } = useGetBinnacle(
    entityTypeId,
    entityId,
    updateBinnacle
  );

  //HOOK GUARDADO DE COMENTARIOS
  const { submittingSave } = useInsertBinnacleComment(executeSave, valuesToSave);

  useEffect(() => {
    if (!isFetchingBinnacle && !submittingSave && entityId !== undefined && entityId !== null) {
      setUpdateBinnacle(!updateBinnacle);
    }
  }, [entityId, submittingSave]);

  const getBinnacleType = (binnacleType: string, binnacleCategoryId: number): string => {
    switch (binnacleType) {
      case 'C':
        // Comment 'C'
        return `entities.comment.category${binnacleCategoryId}`;
      case 'AM': // Audit Modify 'AM'
        return `auditEntities.change.category${binnacleCategoryId}`;
      default:
        // Modify 'M'
        return `entities.change.category${binnacleCategoryId}`;
    }
  };

  const resolveEntityIntlLookUp = (
    value: string,
    i18nLookup: string,
    entityTypeId: number
  ): string => {
    switch (entityTypeId) {
      case entityTypes.ENTITY_UNITS:
        return resolveUnitsIntlLookUp(intl, value, i18nLookup);
      default:
        return '';
    }
  };

  const resolveEntityIntlDescription = (i18nDescription: string): string =>
    intl.formatMessage({ id: i18nDescription });

  const formatBinnacleLog = (binnacleLog: any): string => {
    let comment = '';
    const entityTypeId = binnacleLog.entityTypeId;
    const i18nLookup = binnacleLog.i18NLookup;
    const i18nDescription = binnacleLog.i18NDescription;
    const binnacleComment = binnacleLog.comment;

    if (!i18nLookup && !i18nDescription) return binnacleLog.comment;

    // i18n lookup
    comment = i18nLookup
      ? resolveEntityIntlLookUp(binnacleComment, i18nLookup, entityTypeId)
      : binnacleLog.comment;
    // i18n description
    if (i18nDescription) {
      comment = `${resolveEntityIntlDescription(i18nDescription)}: ${comment}`;
    }

    return comment;
  };

  return entityId && entityTypeId && entityName ? (
    <SlidingPane
      className="custom-sliding-pane"
      overlayClassName="custom-overlay-sliding-pane"
      isOpen={isOpenSlidingPane}
      title={intl.formatMessage({ id: 'common.binnacleChangesComments' })}
      subtitle={entityName}
      width={'40rem'}
      onRequestClose={() => {
        closeSlidingPaneEntityBinnacle();
        reset();
      }}
    >
      <>
        {(isFetchingBinnacle || submittingSave) && (
          <div className="d-flex justify-content-center my-1">
            <Spinner color="primary" />
          </div>
        )}

        <br />
        {binnacleList && binnacleList?.length === 0 && !isFetchingBinnacle && !submittingSave && (
          <div className="misc-inner p-2 p-sm-3">
            <div className="w-100 text-center">
              <h2 className="mb-1">
                <FormattedMessage id="routes.noComments"></FormattedMessage>
              </h2>
            </div>
          </div>
        )}
        {!isFetchingBinnacle && !submittingSave && (
          <div>
            <div className="media-list media-bordered">
              {binnacleList?.map((binnacle: any, i) => {
                return (
                  <Card key={i} className="webtrack bg-white" style={{ marginTop: '-3%' }}>
                    <Media>
                      <Media left>
                        <Avatar
                          // @ts-ignore unreachable error
                          img={binnacle?.userImageUrl ? binnacle?.userImageUrl : undefined}
                          color="light-primary"
                          className={'mr-25'}
                          imgWidth={48}
                          imgHeight={48}
                          content={binnacle?.completeName == null ? '' : binnacle?.completeName}
                          initials
                        />
                      </Media>
                      <Media body>
                        <h6 className="font-weight-bolder mb-25">{binnacle?.completeName}</h6>
                        <CardText>{moment(binnacle?.auditDate).format('lll')}</CardText>
                        <p>{formatBinnacleLog(binnacle)}</p>
                      </Media>
                      <Media right>
                        <Badge
                          pill
                          color="success"
                          style={{
                            display: 'inline-block',
                            fontSize: '12px'
                          }}
                        >
                          {intl.formatMessage({
                            id: getBinnacleType(binnacle?.type, binnacle?.categoryId)
                          })}
                        </Badge>
                      </Media>
                    </Media>
                  </Card>
                );
              })}
            </div>
            <br />
            <br />
            <br />
            <br />
            <Row className={'footer-slide-pane-comments'}>
              <Col sm="10">
                <Controller
                  control={control}
                  name="comment"
                  rules={{ required: true }}
                  render={({ field, fieldState }) => (
                    <TextInput
                      field={field}
                      fieldstate={fieldState}
                      type={'textarea'}
                      required={true}
                      id={'commentInput'}
                    />
                  )}
                />
              </Col>
              <Col>
                <Button.Ripple
                  className={'mb-1'}
                  color="primary"
                  onClick={handleSubmit((values) => {
                    setValuesToSave({
                      entityTypeId,
                      entityId,
                      categoryId:
                        entityTypeId === entityTypes.ENTITY_UNITS
                          ? 5
                          : entityTypeId === entityTypes.ENTITY_VEHICLES
                          ? 6
                          : entityTypeId === entityTypes.ENTITY_SIM_CARDS
                          ? 7
                          : entityTypeId === entityTypes.ENTITY_MODULES
                          ? 8
                          : entityTypeId === entityTypes.ENTITY_DRIVERS
                          ? 21
                          : // : entityTypeId === entityTypes.ENTITY_TRANSPORTISTAS
                          // ? 30
                          // : entityTypeId === entityTypes.ENTITY_NOTIFICATIONS
                          // ? 37
                          entityTypeId === entityTypes.ENTITY_SERVICE_CLASSES
                          ? 41
                          : // : entityTypeId === entityTypes.ENTITY_VEHICLES_COMPONENTS
                          // ? 44
                          // : entityTypeId === entityTypes.ENTITY_VEHICLE_SERVICES
                          // ? 46
                          // : entityTypeId === entityTypes.ENTITY_LOGIN_LOG
                          // ? 47
                          entityTypeId === entityTypes.ENTITY_ORGANIZATIONS
                          ? 55
                          : 0,
                      comment: values?.comment
                    });
                    setExecuteSave(!executeSave);
                    //setUpdateBinnacle(!updateBinnacle);
                    reset();
                  })}
                  disabled={
                    newComment == null ||
                    newComment == '' ||
                    (newComment && newComment?.length == 0)
                  }
                >
                  <Send size={14} />
                </Button.Ripple>
              </Col>
            </Row>
          </div>
        )}
      </>
    </SlidingPane>
  ) : null;
};

SlidingPaneEntityBinnacle.defaultProps = {};

export default SlidingPaneEntityBinnacle;
